import { FC, useMemo } from 'react';
import { SpheraModal } from '@sphera-cloud/component-ui-reactjs';
import './styles.scss';
import { File } from '../../types';
import { Grid, ISpheraGridMetaData } from 'lca-common-ui-components';
import { Link } from 'react-router-dom';

interface Props {
  onClose: () => void;
  selectedFiles: Record<string, File>;
  errors: Record<string, BulkOperationError[]>
}

interface TableData {
  fileId: string,
  name: string,
  errors: BulkOperationError[],
}

export interface BulkOperationError {
  message: string;
  links: BulkOperationErrorLink[]
}

export interface BulkOperationErrorLink {
  title: string,
  to: string,
}

const BulkOperationResultModal: FC<Props> = ({ onClose, selectedFiles, errors }) => {

  const renderErrors = ({ dataItem }: { dataItem: TableData }) => {
    return (<td>
      {dataItem.errors.map((error: BulkOperationError) => (
        <div key={error.message}>
          <div>{error.message.toString()}</div>
          {!!error.links?.length &&
            error.links.slice(0, 3).map((link, index) =>
              <span key={link.title} className='bulk-operations-modal---grid---link'>
                <Link title={link.title} to={link.to} target='blank'>
                  {link.title}
                </Link>
                {index < 3 && (', ')}
              </span>,
            )
          }
          {error.links.length > 3 && (<span className='bulk-operations-modal---grid---link'>...</span>)}
        </div>
      ))
      }
    </td >);
  };

  const metadata: ISpheraGridMetaData[] = useMemo(
    () => [
      { field: 'name', title: 'Name', filterable: true, filterCell: 'text', sortable: true },
      { field: 'error', title: 'Errors', type: 'component', object: '_errors', filterable: false, sortable: true },
    ],
    [selectedFiles],
  );

  const filesData = useMemo(
    () => {
      return Object.keys(errors ?? {}).map((fileId: string) => {
        const row = {
          name: selectedFiles[fileId].name,
          errors: errors[fileId],
        };
        return {
          ...row,
          _errors: (renderErrors({ dataItem: row as TableData }) as any)?.props?.children,
        };
      });
    },
    [errors],
  );

  return (
    <SpheraModal
      className="bulk-operations-modal"
      title="Errors"
      onClose={onClose}
      actionText="Ok"
      onCancel={onClose}
      onAction={onClose}
      wide={true}
    >
      <Grid
        className="bulk-operations-modal---grid"
        pageable
        data={filesData}
        metadata={metadata}
        total={filesData?.length ?? 0}
      />
    </SpheraModal>
  );
};

export default BulkOperationResultModal;
